/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2026-08-05 12:59:36.

export class AnswerData implements Serializable {
    reviews?: number;
    answers?: number;
    responseRate?: number;
    reviewLast24?: number;
    answerLast24?: number;
    answerDelay?: number;

    constructor(data: AnswerData) {
        this.reviews = data.reviews;
        this.answers = data.answers;
        this.responseRate = data.responseRate;
        this.reviewLast24 = data.reviewLast24;
        this.answerLast24 = data.answerLast24;
        this.answerDelay = data.answerDelay;
    }
}

export class AssetData implements Serializable {
    id?: string;
    name?: string;
    content?: string;
    entityIds?: string[];

    constructor(data: AssetData) {
        this.id = data.id;
        this.name = data.name;
        this.content = data.content;
        this.entityIds = data.entityIds;
    }
}

export class AssetsRequest {
    network: Network;
    limit?: number;
    pageToken?: string;

    constructor(data: AssetsRequest) {
        this.network = data.network;
        this.limit = data.limit;
        this.pageToken = data.pageToken;
    }
}

export class CommentDto {
    authorEmail?: string;
    authorRole?: string;
    visibility?: string;
    publisherDate?: number;
    authorName?: string;
    suppressReviewerContact?: boolean;
    id?: number;
    isAutomaticResponse?: boolean;
    content?: string;

    constructor(data: CommentDto) {
        this.authorEmail = data.authorEmail;
        this.authorRole = data.authorRole;
        this.visibility = data.visibility;
        this.publisherDate = data.publisherDate;
        this.authorName = data.authorName;
        this.suppressReviewerContact = data.suppressReviewerContact;
        this.id = data.id;
        this.isAutomaticResponse = data.isAutomaticResponse;
        this.content = data.content;
    }
}

export class CompetitorData {
    poi: FinsaPoi;
    publisherId: string;
    reviews: Review[];

    constructor(data: CompetitorData) {
        this.poi = data.poi;
        this.publisherId = data.publisherId;
        this.reviews = data.reviews;
    }
}

export class CreateRequest {
    name: string;
    content: string;
    entityIds?: string[];

    constructor(data: CreateRequest) {
        this.name = data.name;
        this.content = data.content;
        this.entityIds = data.entityIds;
    }
}

export class DetailedStatistics {
    sourceId?: string;
    name?: string;
    icon?: string;
    publicStats?: Statistic;
    reviewAssociatedStats?: Statistic;
    store?: string;

    constructor(data: DetailedStatistics) {
        this.sourceId = data.sourceId;
        this.name = data.name;
        this.icon = data.icon;
        this.publicStats = data.publicStats;
        this.reviewAssociatedStats = data.reviewAssociatedStats;
        this.store = data.store;
    }
}

export class EngagementData implements Serializable {
    views?: number;
    actions?: number;
    engagementRate?: number;
    directions?: number;
    calls?: number;
    website?: number;
    target?: number;

    constructor(data: EngagementData) {
        this.views = data.views;
        this.actions = data.actions;
        this.engagementRate = data.engagementRate;
        this.directions = data.directions;
        this.calls = data.calls;
        this.website = data.website;
        this.target = data.target;
    }
}

export class EntityData implements Serializable {
    id?: string;
    name?: string;
    address?: string;
    description?: string;
    website?: string;
    phone?: string;
    logo?: string;
    photoGallery?: string[];
    monday?: Opening[];
    tuesday?: Opening[];
    wednesday?: Opening[];
    thursday?: Opening[];
    friday?: Opening[];
    saturday?: Opening[];
    sunday?: Opening[];
    holidays?: Holiday[];
    moreHours?: string;
    facebookPageUrl?: string;
    posts?: string[];

    constructor(data: EntityData) {
        this.id = data.id;
        this.name = data.name;
        this.address = data.address;
        this.description = data.description;
        this.website = data.website;
        this.phone = data.phone;
        this.logo = data.logo;
        this.photoGallery = data.photoGallery;
        this.monday = data.monday;
        this.tuesday = data.tuesday;
        this.wednesday = data.wednesday;
        this.thursday = data.thursday;
        this.friday = data.friday;
        this.saturday = data.saturday;
        this.sunday = data.sunday;
        this.holidays = data.holidays;
        this.moreHours = data.moreHours;
        this.facebookPageUrl = data.facebookPageUrl;
        this.posts = data.posts;
    }
}

export class EntityListData implements Serializable {
    id: string;
    name?: string;
    address?: string;
    logoUrl?: string;
    hasName?: boolean;
    hasDescription?: boolean;
    hasLogo?: boolean;
    hasHours?: boolean;
    hasWebsite?: boolean;
    hasPhone?: boolean;
    hasSocial?: boolean;
    hasImages?: boolean;
    completedPercentage?: number;
    googleAccountId?: string;

    constructor(data: EntityListData) {
        this.id = data.id;
        this.name = data.name;
        this.address = data.address;
        this.logoUrl = data.logoUrl;
        this.hasName = data.hasName;
        this.hasDescription = data.hasDescription;
        this.hasLogo = data.hasLogo;
        this.hasHours = data.hasHours;
        this.hasWebsite = data.hasWebsite;
        this.hasPhone = data.hasPhone;
        this.hasSocial = data.hasSocial;
        this.hasImages = data.hasImages;
        this.completedPercentage = data.completedPercentage;
        this.googleAccountId = data.googleAccountId;
    }
}

export class EntityUpdateRequest implements Serializable {
    name: string;
    description: string;
    website: string;
    phone: string;
    logo: string;
    facebookPageUrl: string;
    photoGallery: string[];
    monday: Opening[];
    tuesday: Opening[];
    wednesday: Opening[];
    thursday: Opening[];
    friday: Opening[];
    saturday: Opening[];
    sunday: Opening[];
    holidays: Holiday[];
    moreHours: string;

    constructor(data: EntityUpdateRequest) {
        this.name = data.name;
        this.description = data.description;
        this.website = data.website;
        this.phone = data.phone;
        this.logo = data.logo;
        this.facebookPageUrl = data.facebookPageUrl;
        this.photoGallery = data.photoGallery;
        this.monday = data.monday;
        this.tuesday = data.tuesday;
        this.wednesday = data.wednesday;
        this.thursday = data.thursday;
        this.friday = data.friday;
        this.saturday = data.saturday;
        this.sunday = data.sunday;
        this.holidays = data.holidays;
        this.moreHours = data.moreHours;
    }
}

export class ExternalId {
    poiId?: string;
    externalId?: string;
    provider?: string;
    googleBusinessUrl?: string;
    organizationId?: string;
    googleVerificationStatus?: string;
    googleVerificationAt?: Date;
    externalUpdatedAt?: Date;
    createdAt?: Date;
    updatedAt?: Date;
    cid?: string;
    googlePlaceId?: string;

    constructor(data: ExternalId) {
        this.poiId = data.poiId;
        this.externalId = data.externalId;
        this.provider = data.provider;
        this.googleBusinessUrl = data.googleBusinessUrl;
        this.organizationId = data.organizationId;
        this.googleVerificationStatus = data.googleVerificationStatus;
        this.googleVerificationAt = data.googleVerificationAt;
        this.externalUpdatedAt = data.externalUpdatedAt;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
        this.cid = data.cid;
        this.googlePlaceId = data.googlePlaceId;
    }
}

export class Filter {
    network?: Network;
    period?: Period;

    constructor(data: Filter) {
        this.network = data.network;
        this.period = data.period;
    }
}

export class FinsaPoi {
    id?: number;
    poiId?: string;
    sourceId?: string;
    source?: string;
    publisherId?: string;
    publisher?: Publisher;
    latitude?: number;
    longitude?: number;
    address?: string;
    lastUpdateDate?: Date;
    name?: string;
    icon?: string;
    types?: string[];
    externalIds?: ExternalId[];
    statistic?: Statistic;

    constructor(data: FinsaPoi) {
        this.id = data.id;
        this.poiId = data.poiId;
        this.sourceId = data.sourceId;
        this.source = data.source;
        this.publisherId = data.publisherId;
        this.publisher = data.publisher;
        this.latitude = data.latitude;
        this.longitude = data.longitude;
        this.address = data.address;
        this.lastUpdateDate = data.lastUpdateDate;
        this.name = data.name;
        this.icon = data.icon;
        this.types = data.types;
        this.externalIds = data.externalIds;
        this.statistic = data.statistic;
    }
}

export class Group {
    type?: string;
    value?: string;

    constructor(data: Group) {
        this.type = data.type;
        this.value = data.value;
    }
}

export class Holiday implements Serializable {
    day: Date;
    closed: boolean;

    constructor(data: Holiday) {
        this.day = data.day;
        this.closed = data.closed;
    }
}

export class KeycloakConfiguration {
    url: string;
    realm: string;
    clientId: string;
    sessionTimeout: number;

    constructor(data: KeycloakConfiguration) {
        this.url = data.url;
        this.realm = data.realm;
        this.clientId = data.clientId;
        this.sessionTimeout = data.sessionTimeout;
    }
}

export class Label implements Serializable {
    id?: number;
    name?: string;

    constructor(data: Label) {
        this.id = data.id;
        this.name = data.name;
    }
}

export class ListingData {
    id?: string;
    locationId?: string;
    cid?: string;
    accountId?: string;
    publisherId?: string;
    status?: string;
    additionalStatus?: string;
    listingUrl?: string;
    loginUrl?: string;
    screenshotUrl?: string;

    constructor(data: ListingData) {
        this.id = data.id;
        this.locationId = data.locationId;
        this.cid = data.cid;
        this.accountId = data.accountId;
        this.publisherId = data.publisherId;
        this.status = data.status;
        this.additionalStatus = data.additionalStatus;
        this.listingUrl = data.listingUrl;
        this.loginUrl = data.loginUrl;
        this.screenshotUrl = data.screenshotUrl;
    }
}

export class ListingsRequest extends Filter {
    publisherIds?: PublisherId[];
    locationIds?: string[];
    limit?: number;
    pageToken?: string;

    constructor(data: ListingsRequest) {
        super(data);
        this.publisherIds = data.publisherIds;
        this.locationIds = data.locationIds;
        this.limit = data.limit;
        this.pageToken = data.pageToken;
    }
}

export class MetaDto {
    eventType?: string;
    uuid?: string;
    timestamp?: string;
    accountId?: string;
    appSpecificAccountId?: string;

    constructor(data: MetaDto) {
        this.eventType = data.eventType;
        this.uuid = data.uuid;
        this.timestamp = data.timestamp;
        this.accountId = data.accountId;
        this.appSpecificAccountId = data.appSpecificAccountId;
    }
}

export class Network {
    tenant?: string;
    brands?: string[];
    regions?: string[];
    subRegions?: string[];
    markets?: string[];
    groups?: string[];
    importers?: string[];
    dealers?: string[];
    dealerNetworks?: string[];
    outlets?: string[];
    areas?: string[];
    zones?: string[];
    agents?: string[];

    constructor(data: Network) {
        this.tenant = data.tenant;
        this.brands = data.brands;
        this.regions = data.regions;
        this.subRegions = data.subRegions;
        this.markets = data.markets;
        this.groups = data.groups;
        this.importers = data.importers;
        this.dealers = data.dealers;
        this.dealerNetworks = data.dealerNetworks;
        this.outlets = data.outlets;
        this.areas = data.areas;
        this.zones = data.zones;
        this.agents = data.agents;
    }
}

export class Opening implements Serializable {
    start: string;
    end: string;

    constructor(data: Opening) {
        this.start = data.start;
        this.end = data.end;
    }
}

export class PaginatedData<T> implements Serializable {
    data?: T[];
    total?: number;
    nextPageToken?: string;

    constructor(data: PaginatedData<T>) {
        this.data = data.data;
        this.total = data.total;
        this.nextPageToken = data.nextPageToken;
    }
}

export class Parameters {
    key?: string;
    value?: string;

    constructor(data: Parameters) {
        this.key = data.key;
        this.value = data.value;
    }
}

export class Period {
    current: PeriodRange;
    previous?: PeriodRange;
    datePreset?: string;

    constructor(data: Period) {
        this.current = data.current;
        this.previous = data.previous;
        this.datePreset = data.datePreset;
    }
}

export class PeriodData<T> implements Serializable {
    current?: T;
    previous?: T;

    constructor(data: PeriodData<T>) {
        this.current = data.current;
        this.previous = data.previous;
    }
}

export class PeriodRange {
    from: Date;
    to: Date;

    constructor(data: PeriodRange) {
        this.from = data.from;
        this.to = data.to;
    }
}

export class Poi {
    id?: string;
    tenant?: string;
    poiPpId?: string;
    dealerId?: string;
    outletId?: string;
    physicalLocation?: string;
    dealerName?: string;
    networkType?: number;
    type?: string;
    brand?: string;
    scope?: string;
    region?: string;
    name?: string;
    address?: string;
    googleMapsLink?: string;
    city?: string;
    commercialName?: string;
    active?: boolean;
    phone?: string;
    postCode?: string;
    country?: string;
    operating?: boolean;
    subscribed?: boolean;
    expirationDate?: number;
    gmbUrl?: string;
    gmbRequired?: boolean;
    emailPoc?: string;
    mainBrand?: string;
    pilot?: boolean;
    timestampSubscribed?: number;
    coOwnership?: boolean;
    timestampCoOwn?: number;
    rtgl?: boolean;
    timestampRtgl?: number;
    live?: boolean;
    timestampLive?: number;
    autoPayment?: boolean;
    reminderCoOwnership?: number;
    ordered?: boolean;
    timestampOrdered?: number;
    gmbListingName?: string;
    billingDealerId?: string;
    subRegion?: string;
    dealerGroup?: string;
    newVehicle?: boolean;
    afterSales?: boolean;
    product?: boolean;
    shopper?: boolean;
    usedVehicle?: boolean;
    primaryNetwork?: string;
    purchase?: number;
    externalIds?: ExternalId[];
    area?: string;
    zone?: string;
    distributor?: string;

    constructor(data: Poi) {
        this.id = data.id;
        this.tenant = data.tenant;
        this.poiPpId = data.poiPpId;
        this.dealerId = data.dealerId;
        this.outletId = data.outletId;
        this.physicalLocation = data.physicalLocation;
        this.dealerName = data.dealerName;
        this.networkType = data.networkType;
        this.type = data.type;
        this.brand = data.brand;
        this.scope = data.scope;
        this.region = data.region;
        this.name = data.name;
        this.address = data.address;
        this.googleMapsLink = data.googleMapsLink;
        this.city = data.city;
        this.commercialName = data.commercialName;
        this.active = data.active;
        this.phone = data.phone;
        this.postCode = data.postCode;
        this.country = data.country;
        this.operating = data.operating;
        this.subscribed = data.subscribed;
        this.expirationDate = data.expirationDate;
        this.gmbUrl = data.gmbUrl;
        this.gmbRequired = data.gmbRequired;
        this.emailPoc = data.emailPoc;
        this.mainBrand = data.mainBrand;
        this.pilot = data.pilot;
        this.timestampSubscribed = data.timestampSubscribed;
        this.coOwnership = data.coOwnership;
        this.timestampCoOwn = data.timestampCoOwn;
        this.rtgl = data.rtgl;
        this.timestampRtgl = data.timestampRtgl;
        this.live = data.live;
        this.timestampLive = data.timestampLive;
        this.autoPayment = data.autoPayment;
        this.reminderCoOwnership = data.reminderCoOwnership;
        this.ordered = data.ordered;
        this.timestampOrdered = data.timestampOrdered;
        this.gmbListingName = data.gmbListingName;
        this.billingDealerId = data.billingDealerId;
        this.subRegion = data.subRegion;
        this.dealerGroup = data.dealerGroup;
        this.newVehicle = data.newVehicle;
        this.afterSales = data.afterSales;
        this.product = data.product;
        this.shopper = data.shopper;
        this.usedVehicle = data.usedVehicle;
        this.primaryNetwork = data.primaryNetwork;
        this.purchase = data.purchase;
        this.externalIds = data.externalIds;
        this.area = data.area;
        this.zone = data.zone;
        this.distributor = data.distributor;
    }
}

export class PostCommentRequest {
    reviewId: string;
    content: string;

    constructor(data: PostCommentRequest) {
        this.reviewId = data.reviewId;
        this.content = data.content;
    }
}

export class PutReviewLabelsRequest {
    reviewId: string;
    labelIds: number[];

    constructor(data: PutReviewLabelsRequest) {
        this.reviewId = data.reviewId;
        this.labelIds = data.labelIds;
    }
}

export class RatingTrendData implements Serializable {
    target?: number;
    ratings?: number;
    reviews?: number;
    date?: Date;
    entityId?: string;

    constructor(data: RatingTrendData) {
        this.target = data.target;
        this.ratings = data.ratings;
        this.reviews = data.reviews;
        this.date = data.date;
        this.entityId = data.entityId;
    }
}

export class ResponseData<T> implements Serializable {
    data?: T;

    constructor(data: ResponseData<T>) {
        this.data = data.data;
    }
}

export class Review {
    id?: number;
    sourceId?: string;
    sourceIdOnStore?: string;
    feedbackIdOnStore?: string;
    reviewDate?: Date;
    responseDate?: Date;
    starRatings?: number;
    sentiment?: number;

    constructor(data: Review) {
        this.id = data.id;
        this.sourceId = data.sourceId;
        this.sourceIdOnStore = data.sourceIdOnStore;
        this.feedbackIdOnStore = data.feedbackIdOnStore;
        this.reviewDate = data.reviewDate;
        this.responseDate = data.responseDate;
        this.starRatings = data.starRatings;
        this.sentiment = data.sentiment;
    }
}

export class ReviewData implements Serializable {
    id?: string;
    dealer?: string;
    dealerName?: string;
    rating?: number;
    comment?: string;
    commentedAt?: Date;
    response?: string;
    respondedAt?: Date;
    responseId?: string;
    commentId?: string;
    url?: string;
    authorName?: string;
    locationId?: string;
    labels?: Label[];
    responded?: boolean;

    constructor(data: ReviewData) {
        this.id = data.id;
        this.dealer = data.dealer;
        this.dealerName = data.dealerName;
        this.rating = data.rating;
        this.comment = data.comment;
        this.commentedAt = data.commentedAt;
        this.response = data.response;
        this.respondedAt = data.respondedAt;
        this.responseId = data.responseId;
        this.commentId = data.commentId;
        this.url = data.url;
        this.authorName = data.authorName;
        this.locationId = data.locationId;
        this.labels = data.labels;
        this.responded = data.responded;
    }
}

export class ReviewDto {
    entityId?: string;
    accountId?: string;
    rating?: number;
    content?: string;
    authorName?: string;
    authorEmail?: string;
    status?: string;
    flagStatus?: string;
    reviewLanguage?: string;
    transactionId?: string;
    invitationId?: string;
    apiIdentifier?: string;
    comments?: CommentDto[];
    publisherDate?: number;
    lastYextUpdateTime?: number;
    externalId?: string;
    id?: number;
    url?: string;
    publisherId?: string;
    labels?: Label[];

    constructor(data: ReviewDto) {
        this.entityId = data.entityId;
        this.accountId = data.accountId;
        this.rating = data.rating;
        this.content = data.content;
        this.authorName = data.authorName;
        this.authorEmail = data.authorEmail;
        this.status = data.status;
        this.flagStatus = data.flagStatus;
        this.reviewLanguage = data.reviewLanguage;
        this.transactionId = data.transactionId;
        this.invitationId = data.invitationId;
        this.apiIdentifier = data.apiIdentifier;
        this.comments = data.comments;
        this.publisherDate = data.publisherDate;
        this.lastYextUpdateTime = data.lastYextUpdateTime;
        this.externalId = data.externalId;
        this.id = data.id;
        this.url = data.url;
        this.publisherId = data.publisherId;
        this.labels = data.labels;
    }
}

export class ReviewLabels {
    id?: number;
    labelIds?: number[];

    constructor(data: ReviewLabels) {
        this.id = data.id;
        this.labelIds = data.labelIds;
    }
}

export class ReviewWebhookRequest {
    meta?: MetaDto;
    review?: ReviewDto;

    constructor(data: ReviewWebhookRequest) {
        this.meta = data.meta;
        this.review = data.review;
    }
}

export class ReviewsRequest {
    network: Network;
    period: Period;
    additionalParameters?: Parameters;
    limit?: number;
    pageToken?: string;

    constructor(data: ReviewsRequest) {
        this.network = data.network;
        this.period = data.period;
        this.additionalParameters = data.additionalParameters;
        this.limit = data.limit;
        this.pageToken = data.pageToken;
    }
}

export class SaveCompetitorsRequest {
    competitorPublisherIds?: string[];
    withinDistance?: number;

    constructor(data: SaveCompetitorsRequest) {
        this.competitorPublisherIds = data.competitorPublisherIds;
        this.withinDistance = data.withinDistance;
    }
}

export interface Serializable {
}

export class StarDistributionData implements Serializable {
    target?: number;
    promoterPerc?: number;
    neutralPerc?: number;
    detractorPerc?: number;
    reviews?: number;
    date?: Date;

    constructor(data: StarDistributionData) {
        this.target = data.target;
        this.promoterPerc = data.promoterPerc;
        this.neutralPerc = data.neutralPerc;
        this.detractorPerc = data.detractorPerc;
        this.reviews = data.reviews;
        this.date = data.date;
    }
}

export class StarsData implements Serializable {
    rating?: number;
    target?: number;
    reviews?: number;
    promoterPerc?: number;
    neutralPerc?: number;
    detractorPerc?: number;
    fiveStar?: number;
    fourStar?: number;
    threeStar?: number;
    twoStar?: number;
    oneStar?: number;
    fiveStarPerc?: number;
    fourStarPerc?: number;
    threeStarPerc?: number;
    twoStarPerc?: number;
    oneStarPerc?: number;

    constructor(data: StarsData) {
        this.rating = data.rating;
        this.target = data.target;
        this.reviews = data.reviews;
        this.promoterPerc = data.promoterPerc;
        this.neutralPerc = data.neutralPerc;
        this.detractorPerc = data.detractorPerc;
        this.fiveStar = data.fiveStar;
        this.fourStar = data.fourStar;
        this.threeStar = data.threeStar;
        this.twoStar = data.twoStar;
        this.oneStar = data.oneStar;
        this.fiveStarPerc = data.fiveStarPerc;
        this.fourStarPerc = data.fourStarPerc;
        this.threeStarPerc = data.threeStarPerc;
        this.twoStarPerc = data.twoStarPerc;
        this.oneStarPerc = data.oneStarPerc;
    }
}

export class Statistic {
    id?: number;
    oneStarCount?: number;
    twoStarCount?: number;
    threeStarCount?: number;
    fourStarCount?: number;
    fiveStarCount?: number;
    ratingCount?: number;
    recurrence?: number;
    avgRating?: number;
    avgSentiment?: number;
    feedbacksCount?: number;
    responseDelay?: number;
    responseCount?: number;

    constructor(data: Statistic) {
        this.id = data.id;
        this.oneStarCount = data.oneStarCount;
        this.twoStarCount = data.twoStarCount;
        this.threeStarCount = data.threeStarCount;
        this.fourStarCount = data.fourStarCount;
        this.fiveStarCount = data.fiveStarCount;
        this.ratingCount = data.ratingCount;
        this.recurrence = data.recurrence;
        this.avgRating = data.avgRating;
        this.avgSentiment = data.avgSentiment;
        this.feedbacksCount = data.feedbacksCount;
        this.responseDelay = data.responseDelay;
        this.responseCount = data.responseCount;
    }
}

export class Topic {
    id?: string;
    name?: string;

    constructor(data: Topic) {
        this.id = data.id;
        this.name = data.name;
    }
}

export class TopicStatisticRequest {
    ids?: string[];

    constructor(data: TopicStatisticRequest) {
        this.ids = data.ids;
    }
}

export class UpdateRequest {
    name: string;
    content: string;
    entityIds?: string[];

    constructor(data: UpdateRequest) {
        this.name = data.name;
        this.content = data.content;
        this.entityIds = data.entityIds;
    }
}

export enum Brand {
    B_AB = 'B_AB',
    B_AC = 'B_AC',
    B_AP = 'B_AP',
    B_AR = 'B_AR',
    B_DO = 'B_DO',
    B_DS = 'B_DS',
    B_FI = 'B_FI',
    B_FP = 'B_FP',
    B_JP = 'B_JP',
    B_LA = 'B_LA',
    B_OV = 'B_OV',
    NHAG = 'NHAG',
    CASEIH = 'CASEIH',
    CASECE = 'CASECE',
    STEYR = 'STEYR',
    MB = 'MB',
    BYD = 'BYD',
    GEELY = 'GEELY',
}

export enum Market {
    AT = 'AT',
    BE = 'BE',
    CZ = 'CZ',
    DE = 'DE',
    ES = 'ES',
    FR = 'FR',
    GB = 'GB',
    IN = 'IN',
    IT = 'IT',
    NL = 'NL',
    PL = 'PL',
    PT = 'PT',
    TR = 'TR',
}

export enum Publisher {
    GOOGLE = 'google',
    FIRSTPARTY = 'firstParty',
}

export enum PublisherId {
    GOOGLEMYBUSINESS = 'GOOGLEMYBUSINESS',
    FACEBOOK = 'FACEBOOK',
    MAPQUEST = 'MAPQUEST',
}

export enum Region {
    EUR = 'EUR',
    ASEAN = 'ASEAN',
    MEA = 'MEA',
    IAP = 'IAP',
    SA = 'SA',
    APAC = 'APAC',
    EMEA = 'EMEA',
    NAR = 'NAR',
}

export enum SubRegion {
    INDIASUBC = 'INDIASUBC',
    SE = 'SE',
    CE = 'CE',
    WEE = 'WEE',
    NE = 'NE',
}
